import { handleActions } from 'redux-actions';
import { FLUJO_THANKUPAGE, LOGOUT } from '../actions';

const stateDefault = {
    flujo : 1
};

/**
 * FLUJO 1 : por defecto muestra thank u page exitoso
 * FLUJO 2 : si no tiene cobertura de deshonestidad y marca robo de empleado
 * FLUJO 3 : si no tiene cobertura por robo y marca robo externo
 * FLUJO 4 : si el monto supera los 8 mil
 */


export default  handleActions(
    {
        [FLUJO_THANKUPAGE]: (state, action) => {
            return Object.assign({}, state, action.payload);
        },
        [LOGOUT] : (state, action) => { 
            return Object.assign({}, stateDefault);
        },
    },
    stateDefault
  );